import script from "./DashboardWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardWidget.vue?vue&type=script&setup=true&lang=js"

import "./DashboardWidget.vue?vue&type=style&index=0&id=4b430000&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b430000"]])

export default __exports__